<template>
  <div id="app">
    <EmployeeIDLookUp />
    <router-view />
  </div>
</template>

<script>
import EmployeeIDLookUp from './components/EmployeeIDLookUp.vue';

export default {
  name: 'App',
  components: {
    EmployeeIDLookUp,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
